import styles from './Text.module.scss';
import React from 'react';
import classNames from 'classnames';
import Icon from '../Icon';
import { customColors } from '../../utilities';

export default function TextWithIcon({
  children,
  className,
  size = 'md',
  weight = 'regular',
  color = 'primary',
  noVerticalMargin = false,
  noMargin = true,
  textAlign = 'left',
  noSelect = false,
  truncate = false,
  onClick = () => {},
  hover,
  link = false,
  icon = undefined,
  leftIcon,
  iconProps = {},
  onRightIconClick = () => {},
  onLeftIconClick = () => {},
  disableLeftIcon = false,
  disableRightIcon = false,
  leftHover,
  rightHover,
}) {
  const getColor = () => {
    if (customColors[color?.toUpperCase()]) {
      return customColors[color?.toUpperCase()];
    }
    return color;
  };

  const getIconColor = () => {
    const iconColor = iconProps?.color || 'primary';
    if (customColors[iconColor.toUpperCase()]) {
      return customColors[iconColor.toUpperCase()];
    }
    return iconColor;
  };
  return (
    <div
      className={classNames(styles.icon, styles[`icon${textAlign}`])}
      onClick={onClick}
    >
      {!!leftIcon && (
        <Icon
          hover={leftHover}
          className={classNames(
            styles[size],
            hover && styles.hover,
            styles[color],
          )}
          style={{
            backgroundColor: 'transparent',
            ...iconProps,
            color: getIconColor(),
          }}
          onClick={onLeftIconClick}
          disabled={disableLeftIcon}
        >
          {leftIcon}
        </Icon>
      )}
      <p
        style={{ color: getColor() }}
        className={classNames(
          styles[size],
          hover && styles.hover,
          noVerticalMargin && styles.noVerticalMargin,
          noSelect && styles.noSelect,
          styles.noMargin,
          styles[weight.toLowerCase()],
          styles[color],
          styles[textAlign],
          truncate && styles.truncate,
          link && styles.blue,
          className,
        )}
      >
        {children}
      </p>
      {(!!icon || !!link) && (
        <Icon
          hover={rightHover}
          disabled={disableRightIcon}
          className={classNames(
            styles[size],
            hover && styles.hover,
            styles[color],
            link && styles.blue,
          )}
          style={{
            backgroundColor: 'transparent',
            ...iconProps,
            color: getIconColor(),
          }}
          onClick={onRightIconClick}
        >
          {link ? 'arrow_right' : icon}
        </Icon>
      )}
    </div>
  );
}
